<div class="grid m-0 p-0">
  <!-- <div class="col-12 m-0 p-0"> -->
    <!-- [(value)]="messages" -->
    <!-- <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
  </div> -->

  <ng-container card-body>
    <div *ngIf="(isLoading$ | async)" class=" w-full flex align-items-center justify-content-center">
      <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
    </div>
  </ng-container>

  <div *ngIf="!(isLoading$ | async)" class="col-12 m-0 p-0 mt-4">
    
    <split-table
      card-body
      [dados]="(lista$ | async)!"
      theme="primary"
      [widthColumns]="[30, 10, 2]"
    >
      <ng-template #header>
        <div class="w-full text-left ml-6">Profissões</div>
      </ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <div class="width-full text-left">
          <span
            class="orange-text ml-6"
            [ngClass]="item.enable ? '' : 'text-disable'"
            >{{ item.name }}</span
          >
        </div>
      </ng-template>

      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha"> </ng-template>

      <ng-template #header></ng-template>
      <ng-template #coluna let-item="dadosLinha">
        <!-- <div class="flex align-items-center justify-content-around mr-4">
          <p-button
            *ngIf="item.enable"
            [rounded]="true"
            size="small"
            [text]="true"
            severity="secondary"
            (onClick)="$event.stopPropagation(); edit(item)" pTooltip="Editar Profissão"
          >
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon name="edit" size="20"></split-icon>
              </div>
            </ng-template>
          </p-button>
          <p-button
            *ngIf="!item.enable"
            [rounded]="true"
            size="small"
            [text]="true"
            severity="secondary"
            [disabled]="true"
            (onClick)="$event.stopPropagation(); edit(item)" pTooltip="Editar Profissão"
          >
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon name="edit"></split-icon>
              </div>
            </ng-template>
          </p-button>
          <p-button
            *ngIf="item.enable"
            [rounded]="true"
            [text]="true"
            severity="orange-primary"
            (onClick)="$event.stopPropagation(); mudarStatusProfissao(item)" pTooltip="Inativar Profissão"
          >
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon size="small" name="ban"></split-icon>
              </div>
            </ng-template>
          </p-button>
          <p-button
            *ngIf="!item.enable"
            [rounded]="true"
            [text]="true"
            severity="success"
            (onClick)="$event.stopPropagation();  mudarStatusProfissao(item)" pTooltip="Ativar Profissão"
          >
            <ng-template pTemplate="icon">
              <div class="flex">
                <split-icon size="small" name="disban"></split-icon>
              </div>
            </ng-template>
          </p-button>
        </div> -->
      </ng-template>
    </split-table>
  </div>
</div>


<p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar unidade">
        <span class="title">
            <p>Tem certeza que deseja inativar</p>
            <p>essa Profissão?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você inativará esse profissão da sua listagem</p>
            <p>padrão.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="inativar" (click)="changeStatusCard()">Inativar</button>
    </ng-template>

</p-dialog>

<p-dialog [(visible)]="mostrarModalAtivar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content">
        <img src="assets/cadastro/active_modal.svg" alt="imagem deletar unidade">
        <span class="title">
            <p>Tem certeza que deseja ativar</p>
            <p>essa Profissão?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você irá ativar essa profissão na sua listagem</p>
            <p>padrão</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="ativar" (click)="changeStatusCard()">Ativar</button>
    </ng-template>

</p-dialog>




<!-- <p-dialog [(visible)]="mostrarModalInativar" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
    [modal]="true">
    <div class="content"> -->
      <!-- <split-icon size="64"  name="alert-ban" ></split-icon> -->
        <!-- <img src="assets/lista-unidade/modal-inativar/inativar-unidade.svg" alt="imagem deletar unidade"> -->
        <!-- <span class="title">
            <p>Tem certeza que deseja</p>
            <p>inativar essa Profissão?</p>
        </span>
        <span class="message">
            <p>Ao confirmar você inativará essa profissão da sua listagem padrão.</p>
        </span>
    </div>
    <ng-template pTemplate="footer">
        <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
        <button class="inativar" (click)="modalDisable()">Inativar</button>
    </ng-template>

</p-dialog> -->
